define(['moduler'], function (Moduler) {
    'use strict';

    return Moduler.create({
        defaults: {
            triggerSelectors: null,
            closeSelectors: null,
            modalElement: null,
            modalElementActiveClass: 'is-open',
            triggerEvent: 'click',
            overlayElement: '.Overlay',
            overlayElementActiveClass: 'Overlay--visible'
        },

        init: function () {
            let self = this;

            self.overlayElement = document.querySelector(self.options.overlayElement);

            self.modalElement = self.el;
            if (self.options.modalElement) {
                self.modalElement = self.el.querySelector(self.options.modalElement);
            }

            document.addEventListener(self.options.triggerEvent, e => {
                if (e.target.closest(self.options.triggerSelectors)) {
                    e.preventDefault();
                    e.stopPropagation();
                    self.open();
                }
            });
            if (self.options.triggerEvent == 'click') {
                document.addEventListener('keydown', e => {
                    if (e.target.closest(self.options.triggerSelectors) && e.key === "Enter") {
                        e.preventDefault();
                        e.stopPropagation();
                        self.open();
                        self.triggeredBy = e.target;
                    }
                });
            }
        },
        open: function () {
            let self = this;
            self.modalElement.classList.add(self.options.modalElementActiveClass);
            self.overlayElement.classList.add(self.options.overlayElementActiveClass);
            self.modalElement.focus();
            function keyDownHandler(e) {
                if ((e.target.closest(self.options.closeSelectors) && e.key === "Enter") || e.key === "Escape") {
                    document.removeEventListener('keydown', keyDownHandler);
                    self.close();
                }
            }
            document.addEventListener('keydown', keyDownHandler);

            function clickCloser(e) {
                if (e.target.closest(self.options.closeSelectors) || e.target == self.overlayElement) {
                    self.close();
                    document.removeEventListener('click', clickCloser);
                }
            }
            document.addEventListener('click', clickCloser);

            setTimeout(function (e) { document.body.classList.add('no-scroll'); }, 200);
        },
        close: function () {
            let self = this;
            self.modalElement.classList.remove(self.options.modalElementActiveClass);
            self.overlayElement.classList.remove(self.options.overlayElementActiveClass);
            if (self.triggeredBy) {
                self.triggeredBy.focus();
                self.triggeredBy = null;
            }
            document.body.classList.remove('no-scroll');
        }
    });
});